import { default as api } from 'config/frontApiConf';

export const getContentService = async (slug = 1) => {
	try {
		let result = await api.get(`/get-blog-details/${slug}`);
		return result;
	} catch (error) {
		return error;
	}
};
